import { render, staticRenderFns } from "./UserDetailsDialog.vue?vue&type=template&id=2d777d09&scoped=true"
import script from "./UserDetailsDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsDialog.vue?vue&type=style&index=0&id=2d777d09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d777d09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
